export type DeliveredFilesInternalNote = {
  invoiceNumber: string | null;
  property: string | null;
  delivered: string | null;
  resolved: boolean;
};

const FIELD = /^-?\s*\*\*(Invoice|Property|Delivered):\*\*\s*(.+)$/i;

const isDeliveredHeading = (line: string) =>
  /^\*{0,2}Supplement files delivered\*{0,2}$/i.test(line.trim());

export const isDeliveredFilesInternalNote = (body?: string | null) => {
  const text = body?.trim();
  if (!text) return false;
  const first = text.split("\n").find((line) => line.trim()) ?? "";
  return (
    isDeliveredHeading(first) || text.includes("**Supplement files delivered**")
  );
};

export const previewDeliveredFilesInternalNote = (body?: string | null) => {
  const parsed = parseDeliveredFilesInternalNote(body);
  if (!parsed) return null;
  const parts = [
    "Files delivered",
    parsed.invoiceNumber,
    parsed.delivered,
  ].filter(Boolean);
  return parts.join(" · ");
};

export const parseDeliveredFilesInternalNote = (
  body?: string | null,
): DeliveredFilesInternalNote | null => {
  if (!isDeliveredFilesInternalNote(body)) return null;

  const result: DeliveredFilesInternalNote = {
    invoiceNumber: null,
    property: null,
    delivered: null,
    resolved: false,
  };

  for (const raw of (body ?? "").split("\n")) {
    const line = raw.trim();
    if (!line) continue;
    if (isDeliveredHeading(line)) continue;
    if (/^ticket marked resolved\.?$/i.test(line)) {
      result.resolved = true;
      continue;
    }
    const match = line.match(FIELD);
    if (!match) continue;
    const value = match[2]?.trim() || null;
    switch (match[1]?.toLowerCase()) {
      case "invoice":
        result.invoiceNumber = value;
        break;
      case "property":
        result.property = value;
        break;
      case "delivered":
        result.delivered = value;
        break;
      default:
        break;
    }
  }

  return result;
};
